import React, { Fragment } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { agregarVisita, eliminarVisita } from '../../../redux/DucksUnidadInspeccion/CalendarioDuck'
import { useSelector, useDispatch } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from 'react-router-dom'
import estilos from './PanelVisitasFormComponent.module.css'

const VisitasFormComponent = (props) => {

    const dispatch = useDispatch()

    const inspectores = props.inspectores
    const domicilios = props.domicilios
    const dia = props.dia
    const mes = props.mes
    const ano = props.ano

    return (
        <Fragment>
            <div className={`mt-3 ${estilos.contenedorBorder}`}>
                <div className='row'>
                        <h1 className={`${estilos.tituloForm}`}>Reasignación de visitas</h1>
                </div>
            <Formik
                initialValues={{ inspector: '', empresa: '', indicacionesAdicionales: '' }}
                validate={values => {
                    const errors = {};
                    if (!values.inspector) {
                        errors.inspector = 'Required';
                    }
                    if (!values.empresa) {
                        errors.empresa = 'Required';
                    }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    const visita = {
                        id: uuidv4(),
                        dia: dia,
                        mes: mes,
                        ano: ano,
                        status: 1,
                        fecha: "" + dia + "-" + mes + "-" + ano,
                        empresa: values.empresa,
                        inspector: values.inspector,
                        indicacionesAdicionales: values.indicacionesAdicionales,
                    }
                    dispatch(agregarVisita(visita))
                    setSubmitting(false);
                    props.history.push('/panelCalendario')
                }}
            >

                {({ isSubmitting }) => (
                    <Form>
                        <div className={`container ${estilos.contenedorForm}`}>
                        <label htmlFor="inspector">Inspector:</label><br />
                        <Field as="select" name="inspector" className='form-control'>
                            <option key='0' value='Seleccione una opción'>Seleccione una opción</option>
                            {
                                inspectores.map((inspector) => (
                                    <option key={inspector.id} value={inspector.nombre}>{inspector.nombre}</option>
                                ))
                            }
                        </Field>
                        <ErrorMessage name="inspector" component="div" className={`${estilos.error}`} /><br />

                        <label htmlFor="empresa">Empresa a visitar:</label><br />
                        <Field as="select" name="empresa" className='form-control'>
                            <option key='0' value='Seleccione una opción'>Seleccione una opción</option>
                            {
                                domicilios.map((domicilio) => (
                                    <option key={domicilio.id} value={domicilio.domicilio}>{domicilio.domicilio}</option>
                                ))
                            }
                        </Field>
                        <ErrorMessage name="empresa" component="div" className={`${estilos.error}`} /><br />

                        <label htmlFor="indicacionesAdicionales">Indicaciones adicionales:</label><br />
                        <Field type="text" name="indicacionesAdicionales" className='form-control'>

                        </Field>
                        <ErrorMessage name="indicacionesAdicionales" component="div" className={`${estilos.error}`} /><br />


                        <div className='text-center'>
                        <button type="submit" disabled={isSubmitting} className='btn btn-lg btn-success'>
                            Agregar visita
                        </button>
                        </div>

                    </div>
                    </Form>
                )}

            </Formik>
        </div>

        </Fragment>
    )
}

export default withRouter(VisitasFormComponent)